import React from "react";
import Modal from "react-modal";

interface Props {
  children: React.ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '12px',
    backgroundColor: '#000026',
  },
  overlay: {
    background: "rgba(255, 255, 255, 0.2)"
  }
};

export default function CustomModal(props: Props) {

  Modal.setAppElement('#app');

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      contentLabel="Example Modal"
      style={customStyles}
    >
      {props.children}
    </Modal>
  )
}